<template>
  <div class="number-item">
    <div style="width: 100%">
      <div class="number-item-num">
        {{ numberText }}
        <span class="number-item-unit">
          {{ numUnit }}
        </span>
      </div>
      <div class="number-item-title">{{ numTitle }}</div>
    </div>
    <!--  边角  -->
    <div class="number-item-corner1"></div>
    <div class="number-item-corner2"></div>
    <div class="number-item-corner3"></div>
    <div class="number-item-corner4"></div>
  </div>
</template>

<script>
export default {
  name: 'numberItem',
  data () {
    return {
      numberText: this.num, // 数字
      numTitle: this.title, // 标题
      numUnit: this.unit // 计量单位
    }
  },
  props: {
    'num': {
      type: Number,
      default: 0
    },
    'title': {
      type: String,
      default: ''
    },
    'unit': {
      type: String,
      default: ''
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
.number-item {
  width: 20%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.number-item-num {
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  font-size: 20px;
}
.number-item-title {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  background-image: linear-gradient(to right, #ffffff, #449dff);
  -webkit-background-clip: text;
  color: transparent;
}
.number-item-unit {
  color: #f0f0f0;
}
.number-item-corner1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 2px solid #77b7fc;
  border-left: 2px solid #77b7fc;
}
.number-item-corner2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 2px solid #77b7fc;
  border-right: 2px solid #77b7fc;
}
.number-item-corner3 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid #77b7fc;
  border-right: 2px solid #77b7fc;
}
.number-item-corner4 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid #77b7fc;
  border-left: 2px solid #77b7fc;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Number_item.vue